import classNames from 'classnames';

import ArrowIcon from '../icons/Arrow';
import Button from './Button';

import styles from '../../../styles/buttons/arrow.module.css';

interface ArrowButtonProps {
    direction?: 'left' | 'right';
    color?: string | null;
    className?: string | null;
    onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    [key: string]: unknown;
}

function ArrowButton({
    direction = 'left',
    color = null,
    className = null,
    ...props
}: ArrowButtonProps) {
    const ariaLabel = direction === 'left' ? 'Previous' : 'Next';

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles[color]]: color !== null,
                },
            ])}
            aria-label={ariaLabel}
            {...props}
        >
            <ArrowIcon
                direction={direction}
                className={classNames(['fullscreen', styles.icon])}
                aria-hidden="true"
            />
        </Button>
    );
}

export default ArrowButton;
